var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"grey lighten-5"},[_c('v-row',{staticClass:"main"},[_c('div',[_c('h1',[_vm._t("default")],2)])]),_c('v-row',[_c('v-col',{staticClass:"leftbox"},[_c('h2',[_vm._t("link-1")],2)]),_c('v-col',[_c('h2',[_vm._t("link-2")],2)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }